module.exports = __webpack_public_path__ + "static/media/contact1.df8a1a7d.png";